import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SEO from "../components/SEO";
import heroScan from "../assets/scan/hero-scan.webp";
import ShareButtons from "../components/ShareButtons";


const initialFormState = {
  name: "",
  email: "",
  phone: "",
  location: "",
  area: "",
  objectType: "flat",
  preferredDate: "",
  message: "",
  consent: false,
};

export default function InteriorScanLanding() {
  const { t, i18n  } = useTranslation();
  const [form, setForm] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus(null);
  setIsSubmitting(true);

  try {
    const payload = {
  lang: (i18n.language || "sr").split("-")[0],
  code: "scan",
  name: form.name.trim(),
  email: form.email.trim(),
  phone: form.phone.trim(),
  message: [
    (form.message || "").trim(),
    "",
    "----- SCAN DETAILS -----",
    `Location: ${form.location.trim()}`,
    `Area: ${form.area || "-"}`,
    `Object type: ${form.objectType || "-"}`,
    `Preferred date: ${form.preferredDate || "-"}`
  ].join("\n"),
  page_url: window.location.href
};

    const res = await fetch("https://modularobjects.com/mailserver/api/leads", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json().catch(() => null);
    if (!res.ok || !data?.ok) throw new Error(data?.error || "Request failed");

    // ✅ ako ima email -> mailserver šalje verify i tek posle toga team-notify + autoresponder
    if (data.needsVerification) {
      setStatus("verify"); // napravi UI poruku: "Proverite email i potvrdite adresu"
    } else {
      setStatus("success");
    }

    setForm(initialFormState);
  } catch (err) {
    console.error(err);
    setStatus("error");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark">
      <SEO
        title={t("scanLanding.seoTitle")}
        description={t("scanLanding.seoDescription")}
      />

      {/* HERO */}
      <header className="relative overflow-hidden border-b border-neutral-200 dark:border-neutral-800">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-light/15 via-background-light to-background-dark/80 dark:from-primary-light/20 dark:via-background-dark dark:to-black pointer-events-none" />
        <div className="relative z-10 max-w-6xl mx-auto px-4 py-10 lg:py-16">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* TEXT SIDE */}
            <div>
              <p className="inline-flex items-center text-xs font-semibold uppercase tracking-[0.25em] text-primary-light mb-4">
                {t("scanLanding.hero.badge")}
              </p>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mb-5">
                {t("scanLanding.hero.titleLine1")}{" "}
                <span className="text-primary-light">
                  {t("scanLanding.hero.titleHighlight")}
                </span>
              </h1>
              <p className="text-sm sm:text-base mb-6 max-w-xl text-neutral-700 dark:text-neutral-200">
                {t("scanLanding.hero.subtitle")}
              </p>

              <div className="flex flex-col sm:flex-row gap-3 mb-8">
                <a
                  href="#scan-form"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-primary-light text-background-light font-semibold text-sm shadow-md shadow-primary-light/40 hover:opacity-90 transition"
                >
                  {t("scanLanding.hero.ctaPrimary")}
                </a>
                <a
                  href="#how-it-works"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl border border-neutral-300 dark:border-neutral-700 text-sm hover:bg-neutral-100 dark:hover:bg-neutral-900 transition"
                >
                  {t("scanLanding.hero.ctaSecondary")}
                </a>
              </div>

              <div className="flex flex-wrap gap-4 text-xs text-neutral-600 dark:text-neutral-300">
                <div className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-light" />
                  {t("scanLanding.hero.bullet1")}
                </div>
                <div className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-light" />
                  {t("scanLanding.hero.bullet2")}
                </div>
                <div className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-light" />
                  {t("scanLanding.hero.bullet3")}
                </div>
              </div>

 <div className="mt-10">
  <ShareButtons
  kind="page"
  lang={i18n.language}   // 👈 OVO DODAJ
  post={{
    title: t("scanLanding.seoTitle"),
    description: t("scanLanding.seoDescription"),
    image: "/images/og/3d-scan.png",
    slug: "3d-scan",
  }}
/>
</div>

            </div>

            {/* VISUAL SIDE */}
            <div className="relative">
  <div className="absolute -inset-6 bg-primary-light/15 blur-3xl -z-10" />
  <div className="rounded-3xl border border-neutral-200 dark:border-neutral-800 bg-background-light/70 dark:bg-neutral-900/70 backdrop-blur-xl p-4 shadow-2xl">
    
    {/* HERO IMAGE */}
    <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-neutral-200/60 dark:border-neutral-700/60 relative">
      <img
        src={heroScan}
        alt={t("scanLanding.footer.serviceName")}
        className="w-full h-full object-cover"
      />

      {/* overlay header (Modular Objects · Leica BLK360) */}
      <div className="absolute left-4 top-4 text-[11px] px-2 py-1 rounded-full bg-black/40 text-white backdrop-blur">
        Modular Objects · Leica BLK360
      </div>

      {/* overlay labels dole levo/desno */}
      <div className="absolute inset-x-4 bottom-3 flex justify-between text-[10px] text-white drop-shadow">
        <span>{t("scanLanding.hero.visualLabelLeft")}</span>
        <span>{t("scanLanding.hero.visualLabelRight")}</span>
      </div>
    </div>

                {/* mini benefit cards */}
                <div className="mt-4 grid sm:grid-cols-3 gap-3 text-xs">
                  <div className="rounded-xl bg-background-light dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700 p-3">
                    <p className="font-semibold text-primary-light mb-1">
                      {t("scanLanding.hero.card1.title")}
                    </p>
                    <p className="text-neutral-600 dark:text-neutral-300">
                      {t("scanLanding.hero.card1.text")}
                    </p>
                  </div>
                  <div className="rounded-xl bg-background-light dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700 p-3">
                    <p className="font-semibold text-primary-light mb-1">
                      {t("scanLanding.hero.card2.title")}
                    </p>
                    <p className="text-neutral-600 dark:text-neutral-300">
                      {t("scanLanding.hero.card2.text")}
                    </p>
                  </div>
                  <div className="rounded-xl bg-background-light dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700 p-3">
                    <p className="font-semibold text-primary-light mb-1">
                      {t("scanLanding.hero.card3.title")}
                    </p>
                    <p className="text-neutral-600 dark:text-neutral-300">
                      {t("scanLanding.hero.card3.text")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* SECTION: HOW IT WORKS */}
      <section
        id="how-it-works"
        className="border-b border-neutral-200 dark:border-neutral-800"
      >
        <div className="max-w-6xl mx-auto px-4 py-12 lg:py-16">
          <div className="flex flex-col lg:flex-row gap-10 lg:items-center">
            <div className="lg:w-1/2">
              <h2 className="text-2xl lg:text-3xl font-semibold mb-3">
                {t("scanLanding.process.title")}
              </h2>
              <p className="text-sm mb-6 max-w-xl text-neutral-700 dark:text-neutral-200">
                {t("scanLanding.process.subtitle")}
              </p>

              <ol className="space-y-4 text-sm text-neutral-900 dark:text-neutral-100">
                {[1, 2, 3, 4].map((step) => (
                  <li key={step} className="flex gap-3">
                    <span className="mt-1 h-6 w-6 rounded-full bg-primary-light/25 text-primary-light flex items-center justify-center text-xs font-semibold">
                      {step}
                    </span>
                    <div>
                      <p className="font-semibold">
                        {t(`scanLanding.process.step${step}.title`)}
                      </p>
                      <p className="text-neutral-600 dark:text-neutral-300">
                        {t(`scanLanding.process.step${step}.text`)}
                      </p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            {/* use case cards */}
            <div className="lg:w-1/2 grid sm:grid-cols-2 gap-4">
              {[1, 2, 3, 4].map((card) => (
                <div
                  key={card}
                  className="rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-background-light dark:bg-neutral-900 p-4"
                >
                  <p className="text-xs uppercase tracking-wide text-primary-light/90 mb-1">
                    {t(`scanLanding.useCases.card${card}.badge`)}
                  </p>
                  <p className="font-semibold text-sm mb-1">
                    {t(`scanLanding.useCases.card${card}.title`)}
                  </p>
                  <p className="text-sm text-neutral-600 dark:text-neutral-300">
                    {t(`scanLanding.useCases.card${card}.text`)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION: FORM */}
      <section
        id="scan-form"
        className="border-b border-neutral-200 dark:border-neutral-800 bg-background-light dark:bg-neutral-950"
      >
        <div className="max-w-6xl mx-auto px-4 py-12 lg:py-16">
          <div className="grid lg:grid-cols-2 gap-10">
            <div>
              <h2 className="text-2xl lg:text-3xl font-semibold mb-3">
                {t("scanLanding.form.title")}
              </h2>
              <p className="text-sm mb-4 max-w-md text-neutral-700 dark:text-neutral-200">
                {t("scanLanding.form.subtitle")}
              </p>
              <ul className="text-sm text-neutral-700 dark:text-neutral-200 space-y-2 mb-6">
                <li>{t("scanLanding.form.bullet1")}</li>
                <li>{t("scanLanding.form.bullet2")}</li>
                <li>{t("scanLanding.form.bullet3")}</li>
              </ul>

              <div className="rounded-2xl border border-primary-light/40 bg-primary-light/10 px-4 py-3 text-xs text-neutral-900 dark:text-neutral-100 max-w-md">
                <p className="font-semibold mb-1">
                  {t("scanLanding.form.noteTitle")}
                </p>
                <p className="text-neutral-900/80 dark:text-neutral-100/90">
                  {t("scanLanding.form.noteText")}
                </p>
              </div>
            </div>

            {/* actual form */}
            <div className="rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-background-light dark:bg-neutral-900 p-5 shadow-lg">
              <form onSubmit={handleSubmit} className="space-y-4 text-sm">
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                      {t("scanLanding.form.name")} *
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={form.name}
                      onChange={handleChange}
                      className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light"
                    />
                  </div>
                  <div>
                    <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                      {t("scanLanding.form.email")} *
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={form.email}
                      onChange={handleChange}
                      className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light"
                    />
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                      {t("scanLanding.form.phone")} *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      value={form.phone}
                      onChange={handleChange}
                      className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light"
                    />
                  </div>
                  <div>
                    <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                      {t("scanLanding.form.location")} *
                    </label>
                    <input
                      type="text"
                      name="location"
                      required
                      value={form.location}
                      onChange={handleChange}
                      className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light"
                    />
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                      {t("scanLanding.form.area")}
                    </label>
                    <input
                      type="number"
                      name="area"
                      min="0"
                      value={form.area}
                      onChange={handleChange}
                      className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light"
                    />
                  </div>
                  <div>
                    <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                      {t("scanLanding.form.objectType")}
                    </label>
                    <select
                      name="objectType"
                      value={form.objectType}
                      onChange={handleChange}
                      className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light"
                    >
                      <option value="flat">
                        {t("scanLanding.form.objectTypeFlat")}
                      </option>
                      <option value="house">
                        {t("scanLanding.form.objectTypeHouse")}
                      </option>
                      <option value="retail">
                        {t("scanLanding.form.objectTypeRetail")}
                      </option>
                      <option value="office">
                        {t("scanLanding.form.objectTypeOffice")}
                      </option>
                      <option value="hall">
                        {t("scanLanding.form.objectTypeHall")}
                      </option>
                      <option value="other">
                        {t("scanLanding.form.objectTypeOther")}
                      </option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                    {t("scanLanding.form.preferredDate")}
                  </label>
                  <input
                    type="date"
                    name="preferredDate"
                    value={form.preferredDate}
                    onChange={handleChange}
                    className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light"
                  />
                </div>

                <div>
                  <label className="block mb-1 text-neutral-900 dark:text-neutral-50">
                    {t("scanLanding.form.message")}
                  </label>
                  <textarea
                    name="message"
                    rows={4}
                    value={form.message}
                    onChange={handleChange}
                    placeholder={t("scanLanding.form.messagePlaceholder")}
                    className="w-full rounded-lg bg-background-light dark:bg-neutral-950 border border-neutral-300 dark:border-neutral-700 px-3 py-2 outline-none focus:border-primary-light focus:ring-1 focus:ring-primary-light resize-none"
                  />
                </div>

                <div className="flex items-start gap-2 text-xs text-neutral-700 dark:text-neutral-200">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={form.consent}
                    onChange={handleChange}
                    className="mt-0.5 h-4 w-4 rounded border-neutral-400 bg-background-light dark:bg-neutral-950 text-primary-light focus:ring-primary-light"
                    required
                  />
                  <span>{t("scanLanding.form.consentText")}</span>
                </div>

                {status === "verify" && (
                  <div className="rounded-lg border border-emerald-500/60 bg-emerald-500/10 px-3 py-2 text-xs text-emerald-800 dark:text-emerald-100">
                    {t("scanLanding.form.success")}
                  </div>
                )}
                {status === "error" && (
                  <div className="rounded-lg border border-rose-500/60 bg-rose-500/10 px-3 py-2 text-xs text-rose-800 dark:text-rose-100">
                    {t("scanLanding.form.error")}
                  </div>
                )}
                {status === "verify" && (
  <div className="rounded-lg border border-amber-500/60 bg-amber-500/10 px-3 py-2 text-xs text-amber-900 dark:text-amber-100">
    {t("scanLanding.form.verify")}
  </div>
)}

                <div className="flex items-center justify-between pt-2">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="inline-flex items-center px-5 py-2.5 rounded-lg bg-primary-light text-background-light text-sm font-semibold hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed transition"
                  >
                    {isSubmitting
                      ? t("scanLanding.form.sending")
                      : t("scanLanding.form.submit")}
                  </button>
                  <p className="text-[10px] text-neutral-500 dark:text-neutral-400">
                    {t("scanLanding.form.responseNote")}
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

     

      {/* FOOTER MINI STRIPE */}
      
    </div>
  );
}
